export default __webpack_public_path__ + "static/media/google_play.6373f091.png";